// Employees might share computers and OS accounts, so two people can end up on
// the same browser profile and therefore the same localStorage. Every value
// that belongs to a person rather than to the machine is stored under this
// prefix, scoped by the OIDC `sub`, so one employee can never read another's
// state — and so signing out can find and drop the tab-scoped half of it in
// one sweep.
export const USER_STORAGE_PREFIX = "medoma.user.";

export const userStorageKey = ({
  userId,
  key,
}: {
  userId: string;
  key: string;
}) => `${USER_STORAGE_PREFIX}${userId}.${key}`;
